/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpvisibility_Saveerror3Inputs */

const en_coinvestments_insights_lpvisibility_saveerror3 = /** @type {(inputs: Coinvestments_Insights_Lpvisibility_Saveerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't update visibility`)
};

/**
* | output |
* | --- |
* | "Couldn't update visibility" |
*
* @param {Coinvestments_Insights_Lpvisibility_Saveerror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpvisibility_saveerror3 = /** @type {((inputs?: Coinvestments_Insights_Lpvisibility_Saveerror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpvisibility_Saveerror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpvisibility_saveerror3(inputs)
});
export { coinvestments_insights_lpvisibility_saveerror3 as "coInvestments_insights_lpVisibility_saveError" }